import * as React from 'react';
import PropTypes from 'prop-types';
import { TableCell, TableRow, Tooltip } from '@mui/material';
import GppGoodIcon from '@mui/icons-material/GppGood';
import ReportProblemIcon from '@mui/icons-material/ReportProblem';

import ORDER_STATUS from '../../../constants/orderStatus';
import toRusError from '../../../utils/toRusError';

import { getCoordinatesFormatted } from '../../../../../../shared/utils/coordinatesFormatting';
import CustomMenu from './CustomMenu/CustomMenu';
import TimeCell from './TimeCell/TimeCell';
import AddressCell from './AdressCell/AdressCell';
import ColorBox from './styles/ColorBox';
import StatusCellBox from './styles/StatusCellBox';
import StatusBox from './styles/StatusBox';
import { useLazyFindAddressQuery } from '../../../../../../entities/logistic/logisticTasks/redux/logisticTasks.api';
import { logisticTasksPetrolResourceActions } from '../../../../../../entities/logistic/logisticTasks/redux/logisticTasksPetrol.slice';

export default function OrderRow({
  row,
  index,
  labelId,
  isItemSelected,
  handleClickRow,
  vehicles,
  assignVehicle,
  dispatch,
  orderPoints,
}) {
  const [findAddress] = useLazyFindAddressQuery();

  const findAddressHandler = (key, address, order) =>
    findAddress(address).then((res) => {
      const resData = res.data?.[0];
      dispatch(
        logisticTasksPetrolResourceActions.setEditedAddresses({
          searchResult: resData,
          order,
          key,
        }),
      );
      return res;
    });

  const loadingCoords =
    row.loadingLat && row.loadingLon
      ? `${getCoordinatesFormatted(row.loadingLat)} ${getCoordinatesFormatted(row.loadingLon, true)}`
      : '';
  const deliveryCoords =
    row.deliveryLat && row.deliveryLon
      ? `${getCoordinatesFormatted(row.deliveryLat)} ${getCoordinatesFormatted(row.deliveryLon, true)}`
      : '';

  return (
    <TableRow
      hover
      role="checkbox"
      tabIndex={-1}
      onClick={() => handleClickRow(row)}
      selected={isItemSelected}
      key={`${row.id}-${index}`}
      sx={{ cursor: 'pointer' }}
    >
      <TableCell padding="checkbox" />
      <TableCell component="th" id={labelId} scope="row" padding="none">
        {index + 1}
      </TableCell>
      <TableCell align="right">
        <CustomMenu
          buttonIcon={<ColorBox color={row.color || 'grey'} />}
          menuItems={vehicles}
          selectedItemId={row.vehicleNumber}
          itemCallback={(vehicle) => assignVehicle(vehicle, row)}
        />
      </TableCell>
      <TableCell align="right">
        <TimeCell row={row} dispatch={dispatch} type="loading" />
      </TableCell>
      <TableCell align="left">
        <TimeCell row={row} dispatch={dispatch} type="unloading" />
      </TableCell>
      <TableCell sx={{ width: '20%' }}>
        <AddressCell
          row={row}
          pointIndex={orderPoints[row.orderNumber].loading?.index}
          coords={loadingCoords}
          addressText={row.addressLoading}
          onChange={(address) => {
            findAddressHandler('addressLoading', address, row).then((res) => {
              const dataItem = res.data?.[0];
              if (dataItem.lat && dataItem.lon) {
                handleClickRow(row, true);
              }
            });
          }}
        />
      </TableCell>
      <TableCell sx={{ width: '20%' }}>
        <AddressCell
          row={row}
          pointIndex={orderPoints[row.orderNumber].unloading?.index}
          coords={deliveryCoords}
          addressText={row.addressUnloading}
          onChange={(address) => {
            findAddressHandler('addressUnloading', address, row).then((res) => {
              const dataItem = res.data?.[0];
              if (dataItem.lat && dataItem.lon) {
                handleClickRow(row, true);
              }
            });
          }}
        />
      </TableCell>
      <TableCell align="right">{row.petrolProduct?.volume}</TableCell>
      <TableCell align="right">{row?.petrolType}</TableCell>
      <Tooltip
        arrow
        placement="left-end"
        title={
          row?.statuses?.length ? (
            row?.statuses?.includes(ORDER_STATUS.OK) ? null : (
              <div>
                {row.color ? (
                  <>
                    <p>плановое время забора: {row.timeWindowFrom}</p>
                    <p>плановое время доставки: {row.timeWindowTo}</p>
                  </>
                ) : null}
                {row?.statuses?.map((err, i) => (
                  <p key={err}>
                    {i + 1} {err !== ORDER_STATUS.OK ? 'предупреждение' : ''} {err ? toRusError(err) : '-'}
                  </p>
                ))}
              </div>
            )
          ) : null
        }
      >
        <TableCell align="left" sx={{ color: 'red' }}>
          <StatusCellBox>
            {row?.statuses?.length ? (
              <StatusBox>
                {row?.statuses?.includes(ORDER_STATUS.OK) ? (
                  <GppGoodIcon sx={{ color: 'green' }} />
                ) : (
                  <>
                    {row?.statuses?.length} <ReportProblemIcon sx={{ color: 'red' }} />
                  </>
                )}
              </StatusBox>
            ) : null}
          </StatusCellBox>
        </TableCell>
      </Tooltip>
      <TableCell align="left">
        <CustomMenu />
      </TableCell>
    </TableRow>
  );
}

OrderRow.propTypes = {
  row: PropTypes.shape().isRequired,
  index: PropTypes.number.isRequired,
  labelId: PropTypes.string.isRequired,
  isItemSelected: PropTypes.bool.isRequired,
  handleClickRow: PropTypes.func.isRequired,
  vehicles: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  assignVehicle: PropTypes.func.isRequired,
  dispatch: PropTypes.func.isRequired,
  orderPoints: PropTypes.shape().isRequired,
};
